import 'react';
import classnames from 'classnames';
import styled, { css } from 'styled-components';
import { jsx } from 'react/jsx-runtime';

let _ = t => t,
  _t,
  _t2;
const visuallyHiddenClassName = 'bui-visually-hidden';

/**
 * Styled Components CSS to hide an element visually while still allowing it to be seen by screen readers.
 *
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { visuallyHiddenCss } from '@thisisbud/bui-react-visually-hidden'
 *
 * function ExampleComponent() {
 *   return <div css={visuallyHiddenCss}>This won't show on the screen</div>
 * }
 * ```
 */
const visuallyHiddenCss = /*#__PURE__*/css(_t || (_t = _`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`));

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledSpan = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledSpan",
  componentId: "sc-31igww-0"
})(_t2 || (_t2 = _`
  ${0}
`), visuallyHiddenCss);

/**
 * A component that hides its children visually while still making them readable by screen readers.
 *
 * @remarks By default the component renders as a `span` tag, but any tag or component can be used via the `as` prop
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { VisuallyHidden } from '@thisisbud/bui-react-visually-hidden'
 *
 * function ExampleComponent() {
 *   return <VisuallyHidden>This won't show on the screen</VisuallyHidden>
 * }
 * ```
 */
function VisuallyHidden(props) {
  const {
    as,
    children,
    className
  } = props;
  return /*#__PURE__*/jsx(StyledSpan, {
    as: as,
    className: classnames(visuallyHiddenClassName, className),
    children: children
  });
}
VisuallyHidden.displayName = 'VisuallyHidden';

export { VisuallyHidden, visuallyHiddenClassName, visuallyHiddenCss };
